import { createFileRoute } from '@tanstack/react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import appHelpers from 'utils/app-urls';
import messages from '../messages';
import useAppLanguage from 'hooks/useAppLanguage';

const cdnURL = appHelpers.getCDNUrl();

export const Route = createFileRoute('/auth/signup/check-email')({
  component: CheckEmail,
});

function CheckEmail() {
  const language = useAppLanguage();
  const validateEmailMessages = messages[language].validateEmail;

  return (
    <div className="mb-14">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <img
          src={`${cdnURL}assets/register/check-your-email.png`}
          alt={validateEmailMessages.umbrellaHandAlt}
          className="center pt-8"
        />
        <h2 className="font-semibold leading-9 m-6 text-2.5x1 text-black text-center">
          {validateEmailMessages.heading}
        </h2>
        <p className="text-lg text-gray-900">
          {validateEmailMessages.emailSentLabel}
          <br />
          <br />
          {validateEmailMessages.emailSentLabel2}
          <br />
          <br />
          {validateEmailMessages.cantFindEmailLabel}
          <br />
          {validateEmailMessages.cantFindEmailLabel2}
        </p>
      </div>
    </div>
  );
}
